import { render } from "./ConfiguracionComponent.vue?vue&type=template&id=3e041332&scoped=true"
import script from "./ConfiguracionComponent.vue?vue&type=script&lang=js"
export * from "./ConfiguracionComponent.vue?vue&type=script&lang=js"

import "./ConfiguracionComponent.vue?vue&type=style&index=0&id=3e041332&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e041332"]])

export default __exports__